export const getGroupEventHandlerProps = props => {
  const {
    groupOnBlurHandlers,
    groupOnChangeHandlers,
    id,
    ...otherProps
  } = props;
  return {
    onBlur: groupOnBlurHandlers && groupOnBlurHandlers[id],
    onChange: groupOnChangeHandlers && groupOnChangeHandlers[id],
    ...otherProps
  };
};